<div class="container">
    <h1>Deseja realmente tornar essa cor a cor padrão do produto?</h1>
    
    <div>
        <app-regular-button [title]="'Cancelar'" (click)="close()" [secondary]="true"></app-regular-button>
        <app-regular-button [title]="'Tornar padrão'" (click)="tornarPadrao()"></app-regular-button>
    </div>
</div>